function BrandLandingFooter({darkMode}: { darkMode: boolean }) {
    return (
        <footer className="merchant-map-landing_footer">
            <div className="merchant-map-landing_footer_logo">
                <a href="https://devourplay.gg" target="_blank" rel="noopener noreferrer">
                    <img
                        src={darkMode ? "/images/devourplay-logo.png" : "/images/devourplay-logo2.png"}
                        alt="DevourPlay Logo"
                    />
                </a>
            </div>
            <div className="merchant-map-landing_footer_disclaimer">
                <div className="merchant-map-landing_footer_disclaimer_options">
                    <a
                        href="https://devourplay.gg/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Privacy Policy
                    </a>
                    <span> | </span>
                    <a
                        href="https://devourplay.gg/terms-of-use"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Terms of Use
                    </a>
                    <span> | </span>
                    <a
                        href="https://devourplay.gg/cookie-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Cookie Policy
                    </a>
                </div>
                <div className="merchant-map-landing_footer_disclaimer_text">
                    © {new Date().getFullYear()} DevourPlay
                </div>
            </div>
        </footer>
    );
}

export default BrandLandingFooter;